// // eslint-disable-next-line import/no-cycle
import utility from './utility';
import variables from '../variables';

const navi = {};
navi.screenWidth = {
  cinema: false, desktop: false, tablet: false, phone: false,
};
navi.currentSize = '';
navi.isItTimeToAddEventListeners = false;
navi.burgerContainerHeight = 0;
navi.selectors = {};
navi.selectors.burgerButton = { element: '.masthead-toggle-bar-toggler', selector: null };
navi.selectors.burgerSlide = { element: '.masthead-slide-out-container', selector: null };
navi.selectors.mainLi = (selector) => `#main-nav-${selector} > li`;// 'nav-main-business > div > ul > li a';
navi.selectors.mainButton = (selector) => `#main-nav-${selector} > li > a`;// 'nav-main-businessm > div > ul > li a';
navi.selectors.hiddenMenu = (selector) => `#main-nav-${selector} > li > ul`;// 'nav-main-business > div > ul > li a';
navi.selectors.toggleNav = (selector) => `#main-nav-${selector} .toggle-nav `;// 'nav-main-business > div > ul > li a';
navi.selectors.chevron = (selector) => `#main-nav-${selector} .toggle-nav i`;// 'nav-main-business > div > ul > li a';
navi.selectors.simplifiedList = ['business', 'cooperative', 'gigazone', 'residential'];
navi.selectors.mainMenus = {
  business: {
    top: '.nav-main-business',
    buttonLi: '',
    buttonLink: '',
    chevron: '',
    hiddenMenu: '',
    toggleSpan: '',
    topSelector: '',
    buttonLiSelector: '',
    buttonLinkSelector: '',
    chevronSelector: '',
    hiddenMenuSelector: '',
    toggleSpanSelector: '',
  },
  cooperative: {
    top: '.nav-main-cooperative',
    buttonLi: '',
    buttonLink: '',
    chevron: '',
    hiddenMenu: '',
    toggleSpan: '',
    topSelector: '',
    buttonLiSelector: '',
    buttonLinkSelector: '',
    chevronSelector: '',
    hiddenMenuSelector: '',
    toggleSpanSelector: '',
  },
  gigazone: {
    top: '.nav-main-gigazone',
    buttonLi: '',
    buttonLink: '',
    chevron: '',
    hiddenMenu: '',
    toggleSpan: '',
    topSelector: '',
    buttonLiSelector: '',
    buttonLinkSelector: '',
    chevronSelector: '',
    hiddenMenuSelector: '',
    toggleSpanSelector: '',
  },
  residential: {
    top: '.nav-main-residential',
    buttonLi: '',
    buttonLink: '',
    chevron: '',
    hiddenMenu: '',
    toggleSpan: '',
    topSelector: '',
    buttonLiSelector: '',
    buttonLinkSelector: '',
    chevronSelector: '',
    hiddenMenuSelector: '',
    toggleSpanSelector: '',
  },
};
navi.getElement = (identifier) => document.querySelector(identifier);

navi.toggleBurgerSlideOut = () => {
  utility.toggleClass(navi.selectors.burgerSlide.selector, 'menu-show');
  utility.toggleClass(navi.selectors.burgerButton.selector, 'menu-opened', 'menu-closed');
};
// #masthead-slide-out-container display block or none when #mastheadToggleButton is clicked
navi.onMenuClickActivatorOff = (identifier) => {
  if (navi.screenWidth.tablet || navi.screenWidth.phone) {
    if (navi.selectors.mainMenus[identifier].toggleSpanSelector) {
      utility.addAndRemoveClasses(
        navi.selectors.mainMenus[identifier].toggleSpanSelector,
        'toggle-off', 'toggle-on',
      );
    }
    if (navi.selectors.mainMenus[identifier].chevronSelector) {
      utility.addAndRemoveClasses(
        navi.selectors.mainMenus[identifier].chevronSelector,
        'fa-chevron-down', 'fa-chevron-up',
      );
    }
    if (navi.selectors.mainMenus[identifier].buttonLiSelector) {
      utility.removeClass(
        navi.selectors.mainMenus[identifier].buttonLiSelector,
        'toggled',
      );
    }
    if (navi.selectors.mainMenus[identifier].hiddenMenuSelector) {
      utility.addAndRemoveClasses(navi.selectors.mainMenus[identifier].hiddenMenuSelector, 'menu-hidden', 'menu-show');
    }
  }
};
navi.onMenuClickActivatorOn = (identifier) => {
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (let i = 0; i < navi.selectors.simplifiedList.length; i++) {
    navi.onMenuClickActivatorOff(navi.selectors.simplifiedList[i]);
  }
  if (navi.screenWidth.tablet || navi.screenWidth.phone) {
    utility.addAndRemoveClasses(navi.selectors.mainMenus[identifier].toggleSpanSelector, 'toggle-on', 'toggle-off');
    utility.addAndRemoveClasses(navi.selectors.mainMenus[identifier].chevronSelector, 'fa-chevron-up', 'fa-chevron-down');
    utility.addClass(navi.selectors.mainMenus[identifier].buttonLiSelector, 'toggled');
    utility.addAndRemoveClasses(navi.selectors.mainMenus[identifier].hiddenMenuSelector, 'menu-show', 'menu-hidden');
    const showingMenu = document.querySelector('.main-nav-with-drop-downs > li > ul.menu-show');
    const distanceToTop = showingMenu.getBoundingClientRect().top;
    const maxHeight = window.innerHeight - distanceToTop;
    utility.css(showingMenu, { 'max-height': `${maxHeight}px` });
  }
};
navi.onMenuClickActivator = (identifier) => {
  if (utility.hasClass(navi.selectors.mainMenus[identifier].toggleSpanSelector, 'toggle-off') && utility.hasClass(navi.selectors.mainMenus[identifier].hiddenMenuSelector, 'menu-hidden')) {
    navi.onMenuClickActivatorOn(identifier);
  } else {
    navi.onMenuClickActivatorOff(identifier);
  }
};
navi.addAndRemoveEventListeners = () => {
  const menuTypes = navi.selectors.simplifiedList;
  /// /////////////////////////////////////////////////////////////////////////////////////////////////
  // I know it is a long function but by making it dynamic the event listeners do not disappear
  /// /////////////////////////////////////////////////////////////////////////////////////////////////

  /// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /// //////// Removing events  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (navi.selectors.burgerButton.selector) {
    navi.selectors.burgerButton.selector.removeEventListener('click', navi.toggleBurgerSlideOut);
  }
  menuTypes.forEach((menuType) => {
    if (navi.selectors.mainMenus[menuType].topSelector) {
      navi.selectors.mainMenus[menuType].topSelector
        .addEventListener('mouseover', () => {
          utility.addClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
        });
      navi.selectors.mainMenus[menuType].topSelector
        .addEventListener('mouseout', () => {
          utility.removeClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
        });
    }
    if (navi.selectors.mainMenus[menuType].toggleSpanSelector) {
      navi.selectors.mainMenus[menuType].toggleSpanSelector
        .addEventListener('click', () => {
          navi.onMenuClickActivator(menuType);
        });
      navi.selectors.mainMenus[menuType].toggleSpanSelector
        .addEventListener('mouseover', () => {
          utility.addClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
        });
      navi.selectors.mainMenus[menuType].toggleSpanSelector
        .addEventListener('mouseout', () => {
          utility.removeClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
        });
    }
    if (navi.isItTimeToAddEventListeners) {
      if (navi.screenWidth.desktop || navi.screenWidth.cinema) {
      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// // starting with desktop // /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
        navi.selectors.mainMenus[menuType].hiddenMenuSelector
          .addEventListener('mouseover', () => {
            utility.addClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
          });
        navi.selectors.mainMenus[menuType].topSelector
          .addEventListener('mouseover', () => {
            utility.addClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
          });
        navi.selectors.mainMenus[menuType].hiddenMenuSelector
          .addEventListener('mouseout', () => {
            utility.removeClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
          });
        navi.selectors.mainMenus[menuType].topSelector
          .addEventListener('mouseout', () => {
            utility.removeClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
          });

      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// // Done with desktop // /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      } else if (navi.screenWidth.tablet || navi.screenWidth.phone) {
      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// // starting with tablet and phone / /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///

        navi.selectors.mainMenus[menuType].toggleSpanSelector
          .addEventListener('click', () => {
            if (utility.hasClass(navi.selectors.mainMenus[menuType].toggleSpanSelector, 'toggle-off') && utility.hasClass(navi.selectors.mainMenus[menuType].hiddenMenuSelector, 'menu-hidden')) {
              utility.removeClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
              utility.addClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
            }
          });

        navi.selectors.mainMenus[menuType].toggleSpanSelector
          .addEventListener('mouseover', () => {
            utility.addClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
          });
        navi.selectors.mainMenus[menuType].toggleSpanSelector
          .addEventListener('mouseout', () => {
            utility.removeClass(navi.selectors.mainMenus[menuType].buttonLiSelector, 'hover');
          });
      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// // done with tablet and phone / /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
      }
    }
  });
  if (navi.screenWidth.phone) {
    /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
    /// / starting with phone / /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
    /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
    if (navi.selectors.burgerButton.selector) {
      navi.selectors.burgerButton.selector.addEventListener('click', navi.toggleBurgerSlideOut);
    }
    /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
    /// / done with phone / /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
    /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// /// ///
  }
};
navi.addToggleIfItDoesntExists = (identifier) => {
  // ul#main-nav-residential > li.menu-item > {a%href Internet, ul.submenu, we need here an span element}
  if (navi.selectors.mainMenus[identifier].toggleSpanSelector === null && !navi.screenWidth.desktop) {
    const toggle = utility.createNode('span', { class: 'toggle-nav toggle-off' });
    const inToggle = utility.createNode('i', { class: 'fa fa-chevron-down', 'aria-hidden': 'true' }, '');
    toggle.append(inToggle);
    navi.selectors.mainMenus[identifier].buttonLiSelector.prepend(toggle);
    utility.addClass(navi.selectors.mainMenus[identifier].buttonLiSelector, 'has-toggle');
  }
};
navi.fullWidthMenu = (identifier) => {
  const clientScreenWidth = window.innerWidth;
  // sizing and css calculation work to make menu full width
  const sizing = {
    residential: 100,
    business: 200,
    gigazone: 300,
    cooperative: 400,
  };
  let width = clientScreenWidth;
  let marginLeft = 60;
  let marginRight = 60;
  let side = 10;
  if (navi.screenWidth.cinema) {
    // width = clientScreenWidth + clientScreenWidth * 0.1;
    marginLeft = 0;
    marginRight = 0;
    side = 20;
  } else if (navi.screenWidth.desktop) {
    // width = clientScreenWidth + clientScreenWidth * 0.1;
    marginLeft = 20;
    marginRight = 0;
    side = 20;
  } else if (navi.screenWidth.tablet) {
    width = clientScreenWidth;
    marginLeft = 40;
    marginRight = 40;
  }
  let dCss = {
    width: `${width}px`,
    height: 'auto',
    left: `-${sizing[identifier] + side}%`,
    right: `-${500 - (sizing[identifier] + side)}%`,
    'margin-right': `-${marginRight}%`,
    'margin-left': `-${marginLeft}%`,
    // 'max-height': `${clientScreenHeight}px`,
  };
  if (navi.screenWidth.phone) {
    dCss = {
      width: `${width}px`,
      padding: '10px',
      height: 'auto',
      'overflow-y': 'scroll',
      'text-align': 'left',
      // 'max-height': `${clientScreenHeight}px`,
    };
  }
  utility.css(navi.selectors.mainMenus[identifier].hiddenMenuSelector, dCss);
};
navi.resetSubmenu = (identifier) => {
  // remove all added styles to element .submenu.
  if (utility.isObject(navi.selectors.mainMenus[identifier].hiddenMenuSelector)) {
    navi.selectors.mainMenus[identifier].hiddenMenuSelector.removeAttribute('style');
  }
};
navi.checkScreenSize = () => {
  const clientScreenWidth = window.innerWidth;
  navi.screenWidth = {
    cinema: false, desktop: false, tablet: false, phone: false,
  };
  document.querySelector('#persistantNavigationBar').style = 'position: absolute; top: -2000px; z-index: 2000;';
  utility.css(document.querySelector('#persistantNavigationBar'), { position: 'absolute', top: ' -2000px', 'z-index': 2000 });
  if (clientScreenWidth >= variables.breakpoints.cinema) { // do computers
    navi.screenWidth.cinema = true;
    return 'cinema';
  } if (clientScreenWidth >= variables.breakpoints.desktop) { // do computers
    navi.screenWidth.desktop = true;
    return 'desktop';
  } if (clientScreenWidth >= variables.breakpoints.tablet) {
    navi.screenWidth.tablet = true;
    return 'tablet';
  } // burger menu
  navi.screenWidth.phone = true;
  utility.css(document.querySelector('#persistantNavigationBar'), { position: 'fixed', top: '0px', 'z-index': 2000 });
  navi.burgerContainerHeight = document.querySelector('.masthead').getBoundingClientRect().height;
  return 'phone';
};
navi.setSelectors = (item) => {
  navi.selectors.mainMenus[item].buttonLi = navi.selectors.mainLi(item);
  navi.selectors.mainMenus[item].buttonLink = navi.selectors.mainButton(item);
  navi.selectors.mainMenus[item].chevron = navi.selectors.chevron(item);
  navi.selectors.mainMenus[item].hiddenMenu = navi.selectors.hiddenMenu(item);
  navi.selectors.mainMenus[item].toggleSpan = navi.selectors.toggleNav(item);
  navi.selectors.mainMenus[item].topSelector = document.querySelector(navi.selectors.mainMenus[item].top);
  navi.selectors.mainMenus[item].buttonLiSelector = document.querySelector(navi.selectors.mainMenus[item].buttonLi);
  navi.selectors.mainMenus[item].buttonLinkSelector = document.querySelector(navi.selectors.mainMenus[item].buttonLink);
  navi.selectors.mainMenus[item].chevronSelector = document.querySelector(navi.selectors.mainMenus[item].chevron);
  navi.selectors.mainMenus[item].hiddenMenuSelector = document.querySelector(navi.selectors.mainMenus[item].hiddenMenu);
  navi.selectors.mainMenus[item].toggleSpanSelector = document.querySelector(navi.selectors.mainMenus[item].toggleSpan);
};
navi.resetAll = () => {
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (let i = 0; i < navi.selectors.simplifiedList.length; i++) {
    navi.setSelectors(navi.selectors.simplifiedList[i]); // will set the ones I can here but on first load this may not have all of them so we need to recall it again if not
    navi.resetSubmenu(navi.selectors.simplifiedList[i]);
  }
};
navi.makeLinklessAnchorsDisabled = () => {
  const all_links = document.querySelectorAll('a[href="#"]');
  for (let i = 0; i < all_links.length; i++) {
    const id = all_links[i].getAttribute('id');
    all_links[i].classList.add('unclickable');
    if (id !== 'jump-to-top' && id !== 'mastheadToggleButton') {
      all_links[i].addEventListener('click', (event) => {
        if (event.preventDefault) { // W3C variant
          event.preventDefault();
        } else { // IE < 9 variant. It doesn't work in older version of IE
          event.returnValue = false;
        }
      });
    }
  }
};
navi.onScreenResize = () => {
  const size = navi.checkScreenSize(); // no need to do it all over again if it is still a tablet
  if (navi.currentSize === size) {
    for (let i = 0; i < navi.selectors.simplifiedList.length; i++) {
      navi.resetSubmenu(navi.selectors.simplifiedList[i]);
      navi.fullWidthMenu(navi.selectors.simplifiedList[i], navi.screenWidth);
    }
  } else {
    navi.currentSize = size;
    navi.isItTimeToAddEventListeners = false;
    navi.addAndRemoveEventListeners(); // remove events only (false above) if they exist.
    navi.resetAll();
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (let i = 0; i < navi.selectors.simplifiedList.length; i++) {
      const item = navi.selectors.simplifiedList[i];
      navi.fullWidthMenu(item, navi.screenWidth);
      navi.addToggleIfItDoesntExists(item);
      // navi.onMenuClickActivatorOff(item);
      navi.setSelectors(item); // calling it again
    }
    navi.selectors.burgerButton.selector = document.querySelector(navi.selectors.burgerButton.element);
    navi.selectors.burgerSlide.selector = document.querySelector(navi.selectors.burgerSlide.element);
    navi.isItTimeToAddEventListeners = true;
    navi.addAndRemoveEventListeners();
    utility.removeListOfClasses(['menu-hidden', 'menu-show', 'has-toggle', 'toggled', 'toggle-on', 'toggle-off']);
    if (navi.screenWidth.tablet || navi.screenWidth.phone) {
      utility.addClasses('.main-nav-with-drop-downs > li > ul.sub-menu', 'menu-hidden');
      utility.addClasses('.main-nav-with-drop-downs > li > span.toggle-nav', 'toggle-off');
      utility.addClasses('.main-nav-with-drop-downs > li > a', 'has-toggle');
    }
  }
};
navi.init = () => {
  navi.onScreenResize();
  window.addEventListener('orientationchange', () => { navi.onScreenResize(); }, false);
  window.addEventListener('resize', () => { navi.onScreenResize(); }, false);
  navi.makeLinklessAnchorsDisabled();
  const jump = document.querySelector('#jump-to-top');
  jump.addEventListener('mouseup', () => {
    document.querySelector('body').scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.querySelector('body').onscroll = () => {
    if (window.scrollY * 2 > window.innerHeight) {
      utility.css(jump, { display: 'block' });
    } else {
      utility.css(jump, { display: 'none' });
    }
    // if (navi.screenWidth.phone) {
    //   // make the menu follow the scroll
    //   document.querySelector('.masthead-slide-out-container').style.top = `${navi.burgerContainerHeight - window.scrollY}px`;
    // }
  };
};
export default navi;
